import classNames from 'classnames';

import s from './TabBar.sss';

type TabBarProps = {
  className?: string;
};

export const TabBar: React.FC<React.PropsWithChildren<TabBarProps>> = ({ children, className }) => (
  <div className={classNames(className, s.root)}>
    {children}
  </div>
);
